export interface Utilities {
    copyLink: (target: HTMLElement, tooltipId: string, displayMs: number) => Promise<void>;
    selectTab: (target: HTMLElement) =>  void;
}

const copyLink = async (target: HTMLElement, tooltipSelector: string, displayMs: number): Promise<void> => {
    await navigator.clipboard.writeText(window.location.href);
    
    const tooltip = target.querySelector(tooltipSelector) as HTMLElement;
    tooltip.style.visibility = 'visible';
    return new Promise((resolve) => {
        setTimeout(() => {
            tooltip.style.visibility = 'hidden';
            resolve();
        }, displayMs);
    });
};

const selectTab = (target: HTMLElement): void => {
    const activeClassName = '__active';
    const listOpenClassName = '__open';
    const componentRoot = target.closest('.dc-tabs') as HTMLElement;
    const tabsList = target.closest('[role="tablist"]') as HTMLElement;
    
    const tabs = tabsList.querySelectorAll('[role="tab"]');
    const tabPanels = componentRoot.querySelectorAll('[role="tabpanel"]');

    tabs.forEach((tab) => tab.classList.remove(activeClassName));
    tabPanels.forEach((tab) => tab.classList.remove(activeClassName));

    const targetTab = target.closest('[role="tab"]') as HTMLElement;
    targetTab.classList.add(activeClassName);

    const targetPanelId = targetTab.getAttribute('aria-controls') ?? '';
    const targetPanel = document.getElementById(targetPanelId) as HTMLElement;
    targetPanel.classList.add(activeClassName);
    tabsList.classList.toggle(listOpenClassName);
}


export const utilities: Utilities = {copyLink, selectTab};